/* ============================================================
   BOWO — behaviour
   One rAF-throttled scroll handler drives every scroll-linked thing,
   so there is a single main-thread cost. No framework, no libraries.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- DATA ---------------------------------------------- */

  // Prices are placeholders. Round, not .99 — .99 is the discount register.
  // d is the diameter at the FOOT, h the overall height, both in cm.
  var SIZES = [
    { k:'S', key:'s', name:'Mažas',     w:'iki 4 kg',  d:14, h:6,  ml:500,  price:24,
      breeds:'Špicas, čihuahua, Jorkšyro terjeras' },
    { k:'M', key:'m', name:'Vidutinis', w:'4-10 kg',   d:17, h:12, ml:900,  price:34,
      breeds:'Taksas, prancūzų buldogas, mopsas' },
    { k:'L', key:'l', name:'Didelis',   w:'nuo 10 kg', d:22, h:20, ml:1800, price:44,
      breeds:'Labradoras, auksaspalvis retriveris, vokiečių aviganis' }
  ];

   /* The water bowl is a second stand bought alongside the first, configured in
     full — its own size, pair and name. It is discounted by a FLAT euro amount,
     not a percentage, and that is not a style choice: this figure has to equal
     what the Shopify "Buy X get Y" automatic discount takes off, or the page
     advertises one price and checkout charges another.

     A percentage cannot hold that line. 15% of 24/34/44 is 3,60/5,10/6,60, so
     the page would round to whole euros and checkout would not — and when the
     stand and the water bowl are different sizes, Shopify discounts whichever
     item it picks rather than the one this page discounted. A flat amount is
     the same money either way.

     CHANGE THIS ONLY TOGETHER WITH THE SHOPIFY DISCOUNT. Admin → Discounts →
     the automatic "Buy X get Y" on the BOWO product, amount off.*/
   var WATER_OFF = 5;
   function waterPrice(size) { return size.price - WATER_OFF; }

  /* `at: 0` means every order gets it and the threshold copy switches itself
     off — set a number and the summary grows a progress rule, the CTA line
     states the figure, and neither can drift from the other. Value and
     contents are placeholders. */
  /* 2026-08-28: the gift is a bag dispenser, not the NFC tag it was. The tag
     carried the engraved name, so the copy about it leaned on the same
     personalisation the stand sells; this one does not, and nothing here should
     imply it does.

     NO `worth`. It used to state a euro value in three places - the CTA line,
     the summary row and the gift card - and a figure invites the arithmetic
     "so the stand is really 19 EUR less", which is the opposite of what a gift
     is for. It is free with every order; that is the whole claim. Re-adding a
     number means re-adding it in all three, so it is gone rather than unused. */
  var GIFT = { at: 0, n: 'Maišelių dėklas',
               d: 'Prisekite prie pavadėlio ir neieškokite, kur pasidėjote maišelius. Tas pats dizainas kaip stovo, su pirmu ritinėliu',
               img: 'bowo-bag-holder.jpg' };

  /* Seven finishes — every one of them photographed. The palette used to carry
     ten; Kreidos balta, Druskos pilkšva and Uogų bordo were dropped on
     2026-08-23 because they had never been shot and never would be, and a
     swatch you cannot show the customer is a promise the page cannot keep.

     `id` is the English colour word on purpose: it is also the filename, so
     pairImg() builds the path straight from the pair with nothing to keep in
     sync. Display names stay Lithuanian.

     `hex` comes from the FLAT SWATCH PNGs shipped alongside the renders
     (product images/*.png) — exact material colours, max deviation 0 across the
     sample. Bronze had no flat swatch, so it is calibrated: the other six give a
     flat/photographed ratio of 1.30/1.41/1.47, applied to bronze's photographed
     cone. Re-derive with tools/palette.py if the materials change.

     `bg`/`ink`/`dark` are the PAGE GROUND and are carried over unchanged from
     the finishes these replace — they are a separate decision from the swatch,
     and changing them would repaint whole sections. That does mean the ground no
     longer matches the swatch for the dark finishes: Samanų žalia is an
     olive-sage chip over a deep-forest room. See the README. */
  var COLORS = [
    { id:'desert-tan',  n:'Smėlinė',        hex:'#E8DBB7', img:'',
      bg:'#EDE7DA', ink:'#181816', dark:false },
    { id:'bronze',      n:'Bronzinė',       hex:'#A06F2E', img:'',
      bg:'#7A5C33', ink:'#F4EEE2', dark:true },
    { id:'terracotta',  n:'Molio raudona',  hex:'#B15533', img:'',
      bg:'#F0E3D6', ink:'#181816', dark:false },
    { id:'brown',       n:'Ruda',           hex:'#7D6556', img:'',
      bg:'#6E5039', ink:'#F3EDE4', dark:true },
    { id:'moss-green',  n:'Samanų žalia',   hex:'#68724D', img:'',
      bg:'#2D4A3C', ink:'#F1EFE6', dark:true },
    { id:'nardo-grey',  n:'Pilka',          hex:'#757575', img:'',
      bg:'#E6E6E4', ink:'#181816', dark:false },
    { id:'charcoal',    n:'Anglies juoda',  hex:'#000000', img:'',
      bg:'#1C1C1C', ink:'#EFEDE5', dark:true }
  ];

  /* The six combinations we put forward, as COLORS ids. No `img` here any more:
     pairImg() derives the file from the pair, so a preset is just a shortcut to a
     custom selection rather than a separate thing with its own asset.
     `hero:false` would keep a pair out of the hero row — nothing needs it now
     that the set is six rather than nine. Every other combination is reachable
     through „Savas derinys“. */
  /* FIVE presets since 2026-08-26: desert-tan / moss-green was dropped, and
     desert-tan / terracotta moved to the front, which makes it the DEFAULT —
     the finish the hero opens in and the studio wears before anything is
     picked. Three things follow from position 0 and have to move with it: the
     hero's initial `src` and `alt` in the markup, the same duo in chapter 03,
     and the preset count quoted in the FAQ and in that chapter's copy.
     bronze / moss-green went the same day, replaced by moss-green / terracotta.
     This list is exactly the set of pairs that has a v2 duo shot, and it is not
     a coincidence: `setHeroShot` falls back to the SINGLE for anything without
     one, so a preset with no duo would be the only swatch showing one stand. */
  var PAIRS = [
    { top:'desert-tan',  base:'terracotta' },
    { top:'moss-green',  base:'desert-tan' },
    { top:'charcoal',    base:'desert-tan' },
    { top:'desert-tan',  base:'bronze'     },
    { top:'moss-green',  base:'terracotta' }
  ];
  var IMG_L = 'assets/img/lifestyle/';

  /* ---------- WHERE THE PICTURES ACTUALLY LIVE ------------------- */
  /* Two homes, one file. On the static site an image is a path under
     assets/img/, and every path in here is written that way. On Shopify the
     theme's assets/ is FLAT and served from a CDN under a hashed URL, so a path
     cannot be built by concatenation at all — the section renders a filename to
     URL map into #bw-assets and this resolves against it.
     Filename is the key because it is the one part both worlds agree on: the
     port flattens every assets/img subfolder into a single assets/ and the
     names were already unique. No map on the page (the static site) means the path is
     returned untouched, so nothing here needs to know which world it is in. */
  var ASSETS = (function () {
    try {
      var el = document.getElementById('bw-assets');
      return el ? JSON.parse(el.textContent) : null;
    } catch (e) { return null; }
  })();
  function asset(path) {
    if (!ASSETS || !path) return path;
    return ASSETS[path.split('/').pop()] || path;
  }

  // The hero is one transition: paper into whichever finish is selected.
  // Because it lands exactly on that finish, the rest of the page simply
  // continues in it — no second colour decision anywhere.
  var PAPER = { bg:'#F3F0E8', ink:'#181816', dark:false };

  var FAQ = [
    { q:'Ar galima rinktis dvi spalvas?',
      /* quotes PAIRS.length and COLORS.length — update both here and in the
         `03 — Spalvos` chapter copy whenever either array changes. */
      a:'Taip. Spalvų skiltyje rasite penkis paruoštus derinius, o pasirinkę „Savas derinys“ - septynis atspalvius viršui ir tiek pat pagrindui. Derinį matote iš karto.' },
    { q:'Kur atsiduria vardas?',
      /* „įspaudžiamos“, matching the `05 — Vardas` heading. The other
         „įleidžiamas“ below is the steel bowl seating into the stand — a
         different action, deliberately left alone. */
      a:'Priekinėje pagrindo juostoje - ten, kur paprastai būna prekės ženklas. Raidės įspaudžiamos gaminimo metu, todėl yra to paties paviršiaus dalis.' },
    { q:'Ar galima plauti indaplovėje?',
      a:'Plieninis dubenėlis išimamas ir plaunamas indaplovėje. Stovą valykite drėgna šluoste.' },
    { q:'Nerandu norimos spalvos. Ką daryti?',
      /* The seven finishes are what is stocked, not what is possible. This
         answer is the same offer the custom picker makes under its swatches;
         if custom colours ever stop being feasible, both have to change. */
      a:'Parašykite mums - jei ieškote atspalvio, kurio sąraše nėra, dažniausiai galime pagaminti pagal jūsų pageidavimą. Parašykite, kokios spalvos norėtumėte, ir pasiūlysime sprendimą.' },
    { q:'Kaip pasirinkti dydį?',
      a:'Rinkitės pagal augintinio svorį: iki 4 kg - S, 4-10 kg - M, nuo 10 kg - L. Jei gyvūnas tarp dviejų dydžių, rinkitės didesnį.' },
    /* Answers go in through innerHTML, so a link is possible here - and this is
       the one answer that needs one, because "parašykite" without somewhere to
       write is an instruction with no next step. data-contact rather than a
       hardcoded href: the same wiring the colour pickers use, so all of them
       point at the contact section on Shopify and at mail on the static page. */
    { q:'Ar galite pagaminti kitokio dydžio, spalvos ar formos?',
      a:'Dažnai taip. Jei reikia kitokio aukščio, kitokios formos ar atspalvio, kurio sąraše nėra - <a data-contact>susisiekite</a> ir aptarsime galimybes, terminą bei kainą.' },
    { q:'Kokias raides galima naudoti vardo išliejimui?',
      a:'Iki 12 simbolių: lietuviškos ir lotyniškos didžiosios raidės, tarpas ir brūkšnelis. Skaičių, emoji ir kitų simbolių negaminame.' },
    { q:'Per kiek laiko gausiu?',
      a:'Kiekvienas stovas gaminamas pagal užsakymą. Pagaminame per 3-5 darbo dienas, kurjeris pristato per 1-2.' },
    { q:'Ar galiu grąžinti, jei išlietas vardas?',
      a:'Taip. Grąžinimo terminas - 14 dienų nuo gavimo, ir personalizuotas gaminys nėra išimtis.' }
  ];

  /* The strip is the social set now: six photographs sent in by customers,
     every one of them showing a stand with that dog's own name cut into the
     plinth. That is why each carries its own alt text instead of one repeated
     line — the name on the plinth is the whole point of the section, and a
     screen reader that hears "kliento nuotrauka" fourteen times learns nothing.
     Filename IS the engraved name, lowercased and stripped of diacritics, the
     same rule the packshots follow.
     They replace the fourteen assets/img/ugc/laimingas-*.jpg frames, which were
     the previous supplier's photographs and showed the old, unengraved stand.
     Those files are still on disk and nothing renders them. */
  var UGC = [
    /* Six photographs, every one of them the v2 object. The first two are of a
       stand that has actually been PRINTED; the other four are the renders that
       replaced the cone-era set on 2026-08-31, and they carry the engraved name
       on the plinth, which is the thing this strip is really showing.
       bleizas-bowo is the one file not named after an engraving - its plinth
       reads BOWO, so the stem is the one it arrived with. */
    { f:'bleizas-bowo.jpg', a:'Berno zenenhundas geria iš pakelto BOWO stovo' },
    { f:'hugo.jpg',     a:'Hugo, auksaspalvis retriveris, geria iš savo BOWO stovo lauko terasoje' },
    { f:'amigo.jpg',    a:'Amigo, springerspanielis, ėda iš savo BOWO stovo virtuvėje' },
    { f:'matilda.jpg',  a:'Matilda, maltietis šuniukas, prie savo BOWO stovo su vandeniu' },
    { f:'pupa.jpg',     a:'Pupa, Džeko Raselo terjeras, ėda iš savo BOWO stovo svetainėje' },
    { f:'yoko.jpg',     a:'Yoko, bordercolis, prie savo BOWO stovo virtuvėje' }
  ];

  // colors/*.jpg are the old single-colour packshots and nothing renders them
  // any more; the `img` field on COLORS is kept only for the eventual reshoot.
  var IMG_U = 'assets/img/social/';

  /* Where "Susisiekite" points. The theme knows the real page URL and puts it on
     <body>; the static page has no pages at all, so it falls back to mail —
     which is honest rather than a link to nowhere. Set on every [data-contact]
     at boot AND after renderLines, because the order cards are built later and
     carry their own copy of the same offer. */
  var CONTACT = (document.body && document.body.getAttribute('data-contact-url')) ||
                'mailto:labas@bowo.lt';
  function wireContact(root) {
    $$('[data-contact]', root).forEach(function (a) { a.setAttribute('href', CONTACT); });
  }

  // keeps a phrase on one line wherever it lands
  function nb(t) { return String(t).replace(/ /g, '\u00A0'); }

  /* ---------- HELPERS -------------------------------------------- */
  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || document).querySelectorAll(s)); };
  var root = document.documentElement;
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp01 = function (v) { return v < 0 ? 0 : v > 1 ? 1 : v; };
  var eur = function (n) { return n + ' €'; };
  var mix = function (a, b, p) {
    // oklab keeps the midpoint perceptually even; sRGB goes muddy through grey.
    // One decimal, not Math.round — 100 integer steps band visibly over a
    // short scroll distance.
    return 'color-mix(in oklab, ' + a + ' ' + ((1 - p) * 100).toFixed(1) + '%, ' + b + ')';
  };

  /* ONE list, one truth. Each entry is a stand the customer has configured.
     ORDER[0] is also what the studio upstairs is editing, so the two can never
     disagree — the previous model kept a studio `state` beside a separate
     `cart`, which let the page show one configuration and check out another.
     The default is PAIRS[0], so reordering the presets moves the whole opening
     state with it — the hero resolves into that finish and the studio is
     already wearing it when you arrive. It used to name the ids here, which
     meant the first swatch and the default could silently disagree. */
  function newLine(from) {
    return { size:  from ? from.size : 'm',
             top:   from ? from.top  : byId(PAIRS[0].top),
             base:  from ? from.base : byId(PAIRS[0].base),
             name:  '', qty: 1, water: null };
  }
  /* Seeded from the stand it is bought with — a second bowl for the same dog is
     usually the matching one — and editable from there. */
  function newWater(l) { return { size: l.size, top: l.top, base: l.base, name: l.name }; }

  /* "0" is line one's stand, "0w" is its water bowl. One resolver, so the
     colour control and the name field work identically for both. */
  function target(key) {
    var l = ORDER[parseInt(key, 10)];
    return (/w$/.test(key) && l) ? l.water : l;
  }
  var ORDER = [newLine()];
  // the page ground, hero fade and thumbnails all key off line one's top finish
  var state = { picked: false };
  Object.defineProperty(state, 'color', { get: function () { return ORDER[0].top; } });

  function sizeOf(line) {
    for (var i = 0; i < SIZES.length; i++) if (SIZES[i].key === line.size) return SIZES[i];
    return SIZES[1];
  }
  // the water bowl is priced off its OWN size now, not the stand's
  function lineTotal(line) {
    var t = sizeOf(line).price;
    if (line.water) t += waterPrice(sizeOf(line.water));
    return t * line.qty;
  }
  function orderSubtotal() {
    return ORDER.reduce(function (t, l) { return t + lineTotal(l); }, 0);
  }
  function orderCount() {
    return ORDER.reduce(function (t, l) { return t + l.qty * (l.water ? 2 : 1); }, 0);
  }
  function giftOn() { return orderSubtotal() >= GIFT.at; }

  /* ---------- SCOPED COLOUR --------------------------------------
     --bg/--ink inherit, so painting a section colours that subtree only.
     The rest of the site stays on the light default. */
  function paintEl(el, bg, ink, isDark) {
    if (!el) return;
    el.style.setProperty('--bg', bg);
    el.style.setProperty('--ink', ink);
    if (isDark === undefined) return;
    if (isDark) el.setAttribute('data-dark', ''); else el.removeAttribute('data-dark');
  }

  /* ---------- EASED ANCHOR SCROLL --------------------------------- */
  function smoothTo(el) {
    var start = window.scrollY;
    var end = Math.round(el.getBoundingClientRect().top + start);
    var dist = end - start;
    if (!dist) return;
    var dur = Math.min(1400, Math.max(600, Math.abs(dist) * 0.42));
    var t0 = performance.now();
    (function step(now) {
      var p = Math.min(1, (now - t0) / dur);
      var e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      window.scrollTo(0, start + dist * e);
      if (p < 1) requestAnimationFrame(step);
    })(t0);
  }

  function initAnchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var id = a.getAttribute('href');
      if (!id || id === '#') return;
      var t = document.querySelector(id);
      if (!t) return;
      e.preventDefault();
      if (REDUCED) { t.scrollIntoView(); return; }
      smoothTo(t);
    });
  }

  /* ---------- 1. HERO -------------------------------------------- */
  var hero = { el: $('[data-hero]'), ink: '' };

  function heroInit() {
    if (!hero.el) return;
    heroPaint();
  }

  /* The hero wears the selected finish for its whole height and keeps it.
     It used to resolve to paper on the way out — a scroll-driven mix from the
     finish to PAPER over 1.25 hero-heights — so the dark ground belonged to the
     hero alone and the rest of the site was light. That fade is gone by
     request: the ground is now whatever finish is selected, full strength,
     until the section ends. Two things follow. The boundary with the film
     section below is a hard edge rather than a blend, which is the point. And
     `hero.ink` is now constant, so the nav keeps the finish's ink for the whole
     hero instead of drifting to dark ink as you scroll. */
  function heroPaint() {
    if (!hero.el) return;
    var c = state.color;
    hero.ink = c.ink;
    paintEl(hero.el, c.bg, c.ink, c.dark);
  }

  /* ---------- 2. CHAPTERS (horizontal scrub) --------------------- */
  var chap = { el: $('[data-chap]'), track: null, bar: null, span: 0, panels: [], centres: [], active: -1 };
  /* Dead zone at the top of the section: the track holds still for this much of
     the scroll before it starts travelling. Back up from 0.06 now that the
     opening argument is the first PANEL again rather than a heading above the
     section — it has to be readable on arrival, and at 0.06 the track began
     sliding while you were still in the first sentence. Note this also
     lengthens the section: height divides by (1 - CHAP_HOLD). */
  var CHAP_HOLD = 0.14;

  function chapMeasure() {
    if (!chap.el || !chap.track) return;
    chap.span = Math.max(0, chap.track.scrollWidth - window.innerWidth);
    // Cache each panel's centre once. offsetLeft is layout-based and immune
    // to the track's transform, so the active panel can be derived per frame
    // with no DOM reads — reading rects after writing the transform would
    // thrash layout on every scroll event.
    chap.panels = $$('.ch', chap.track);
    chap.centres = chap.panels.map(function (el) { return el.offsetLeft + el.offsetWidth / 2; });
    // One pixel of scroll = one pixel sideways, plus a hold at the start so
    // the opening line can be read before anything begins moving.
    if (horizontal.matches && !REDUCED && chap.span > 0) {
      // 0.72 px of scroll per px sideways — 1:1 makes eight panels feel endless
      chap.el.style.height = (window.innerHeight + (chap.span * 0.72) / (1 - CHAP_HOLD)) + 'px';
      chap.el.classList.add('is-scrub');
    } else {
      chap.el.style.height = '';
      chap.el.classList.remove('is-scrub');
      chap.track.style.transform = '';
      chap.panels.forEach(function (el) { el.classList.remove('is-on'); });
      chap.active = -1;
    }
  }
  function chapInit() {
    if (!chap.el) return;
    chap.track = $('[data-chap-track]', chap.el);
    chap.bar = $('[data-chap-bar]', chap.el);
    chapMeasure();
  }
  function chapFrame(p) {
    if (!chap.track || !chap.span) return;
    var q = clamp01((clamp01(p) - CHAP_HOLD) / (1 - CHAP_HOLD));
    var shift = chap.span * q;
    chap.track.style.transform = 'translate3d(' + (-shift).toFixed(1) + 'px,0,0)';
    if (chap.bar) chap.bar.style.width = (q * 100).toFixed(1) + '%';

    // whichever panel sits nearest the middle of the window is the one being read
    var mid = window.innerWidth / 2, best = -1, bestD = Infinity;
    for (var i = 0; i < chap.centres.length; i++) {
      var d = Math.abs(chap.centres[i] - shift - mid);
      if (d < bestD) { bestD = d; best = i; }
    }
    if (best !== chap.active) {
      if (chap.panels[chap.active]) chap.panels[chap.active].classList.remove('is-on');
      if (chap.panels[best]) chap.panels[best].classList.add('is-on');
      chap.active = best;
    }
  }

  /* ---------- 3. ONE SCROLL HANDLER ------------------------------ */
  // The bar arrives right after the product reveal, not at the end — the
  // purchase path should be one tap away for most of the page.
  var nav = $('[data-nav]'), bar = $('[data-bar]'), barAfter = $('#gaminys');
  var studioEl = $('[data-studio]');
  var horizontal = window.matchMedia('(min-width:901px)');

  /* Runs straight off the scroll event rather than through rAF. Browsers
     already coalesce scroll to one event per frame, and a rAF-gated flag
     latches permanently if a frame is ever dropped (backgrounded tab,
     throttled renderer) — which silently kills every scroll effect. */
  function frame() {
    // ---- read: every layout query first, batched ----
    var vh = window.innerHeight;
    var scrolled = window.scrollY > 24;

    // the hero's ground no longer moves with the scroll, so nothing to drive —
    // only its bottom edge still matters, for handing the nav its ink
    var heroBottom = hero.el ? hero.el.getBoundingClientRect().bottom : 0;
    var chapTop = 0, chapTravel = 0, chapOn = horizontal.matches && !REDUCED && !!chap.el;
    if (chapOn) {
      chapTop = chap.el.getBoundingClientRect().top;
      chapTravel = chap.el.offsetHeight - vh;
    }
    var barUp = bar && barAfter ? barAfter.getBoundingClientRect().bottom < 0 : false;

    // ---- write ----
    nav.classList.toggle('is-stuck', scrolled);
    // the bar sits over the hero's ground first, then over light content
    nav.style.setProperty('--nav-ink', (hero.el && heroBottom > 72) ? hero.ink : '');
    if (chapOn && chapTravel > 0) chapFrame(-chapTop / chapTravel);
    if (bar) bar.classList.toggle('is-up', barUp);
  }

  var onScroll = frame;

  /* ---------- 4. THE NAME ---------------------------------------- */
  var NAME_OK = /[A-Za-zĄĆČĘĖĮŠŲŪŽąčęėįšųūž \-]/;
  var studioWords = [], studioMarks = [];

  /* The giant word in the studio, plus the deboss on the drawn plinth. Only
     ever shows line one's name — that is the stand the studio is designing. */
  function setWord(v) {
    var txt = v || 'GRIKIS';
    /* THE BIG WORD IS THE NAME AGAIN.

       It was the fixed BOWO mark for as long as the plinths in the photography
       were blank and the name could be laid onto the plinth itself, which is
       where it physically is. The 2026-08-26 renders put a printed BOWO back on
       the plinth, so an overlaid name would sit next to a logo that contradicts
       it. Until the plinths are clean again the personalisation lives in the
       mark: empty input shows BOWO, and the first keystroke replaces it. That
       is also the honest read of the section - you type a name, the name is
       what changes.

       One <i> per letter, as the hero mark does, so both shape and kern the
       same way. The word is drawn TWICE by the markup: the copy behind the
       block and the faint copy over it. Both carry data-studio-word, so both
       land here and neither can drift.

       Empty input shows BOWO, not the GRIKIS placeholder the field carries: an
       untouched section should read as the brand, and the swap on the first
       keystroke is the whole point. GRIKIS still stands in for the dormant
       plinth overlay below, which is a preview of an engraving rather than the
       mark. */
    var word = v || 'BOWO';
    studioWords.forEach(function (w) {
      w.textContent = '';
      for (var i = 0; i < word.length; i++) {
        var s = document.createElement('i');
        s.textContent = word.charAt(i);
        w.appendChild(s);
      }
    });
    /* The plinth overlay is dark for the same reason: see setStudioShot. Its
       text is still kept current so switching back is one line, not a rebuild. */
    var overlay = $('[data-block-name-t]');   // the <textPath>, riding the arc
    if (overlay) overlay.textContent = txt;
    // Both deboss copies on the fallback drawing — the cut and the light
    // catching its lower edge. The drawing only appears for a pair that has no
    // photograph, and every pair has one, so this is dormant.
    studioMarks.forEach(function (m) { m.removeAttribute('textLength'); m.textContent = txt; });
    if (studioMarks[0] && studioMarks[0].getComputedTextLength &&
        studioMarks[0].getComputedTextLength() > 250) {
      studioMarks.forEach(function (m) {
        m.setAttribute('textLength', 250);
        m.setAttribute('lengthAdjust', 'spacingAndGlyphs');
      });
    }
    sizeWord(word);
    fitWord();
  }

  /* An ESTIMATE, corrected by measurement in fitWord(). Two terms, as before:

     - the middle one is a fit. BOWO's advance is 2.94em at this weight and
       tracking — about .735em a letter — so gutter-to-gutter over .78 x length
       lands any name just inside the page margins, with the slack as air. A
       flat vw term cannot do this once the string length varies: 37.5vw put
       four letters at 1.10x the viewport on a phone and overflow:clip ate the O
       without a mark on screen to show for it.
     - the ceiling keeps the word about the same WIDTH whatever the length,
       which is what stops a two-letter name reading as a poster and a
       twelve-letter one as a caption. 360px is the cap for short names. */
  function sizeWord(txt) {
    var len = Math.max(txt.length, 2);
    root.style.setProperty('--name-size',
      'clamp(28px, calc((100vw - 2 * var(--edge)) / ' + (0.78 * len).toFixed(2) +
      '), min(360px, ' + Math.round(1700 / len) + 'px))');
  }

  /* The estimate above assumes an average letter. Names do not have to oblige —
     MIA is narrow, WOLFGANG is not — so measure what actually rendered and
     scale it down if it is wider than the section. Width is linear in
     font-size, so the correction is exact in one pass; --name-fit multiplies
     --name-size in the CSS. Reset before measuring, or each pass would compound
     the last one. Also runs on resize, since the miss is width-dependent. */
  function fitWord() {
    var w = studioWords[0];
    if (!w || !w.parentElement) return;
    root.style.removeProperty('--name-fit');
    var avail = w.parentElement.clientWidth, have = w.getBoundingClientRect().width;
    if (avail > 0 && have > avail) {
      root.style.setProperty('--name-fit', (avail / have).toFixed(3));
    }
  }

  function cleanName(raw) {
    var clean = '', dropped = false;
    for (var i = 0; i < raw.length; i++) {
      if (NAME_OK.test(raw[i])) clean += raw[i]; else dropped = true;
    }
    return { clean: clean.toUpperCase().slice(0, 12), dropped: dropped };
  }

  /* Several inputs can edit one line — the studio and order line one are two
     views of the same field — so mirroring is keyed on the line index carried
     in data-name-for, not on "every name input on the page". */
  function bindName(input) {
    var key = input.dataset.nameFor;
    input.addEventListener('input', function () {
      var r = cleanName(input.value);
      if (input.value !== r.clean) input.value = r.clean;
      var t = target(key);
      if (!t) return;
      t.name = r.clean.trim();
      $$('[data-name-for="' + key + '"]').forEach(function (n) { if (n !== input) n.value = r.clean; });
      $$('[data-name-count="' + key + '"]').forEach(function (n) { n.textContent = r.clean.length; });
      // reject what we cannot physically print rather than passing it downstream
      $$('[data-name-warn="' + key + '"]').forEach(function (n) {
        n.hidden = !r.dropped;
        if (r.dropped) n.textContent = 'Gaminame tik raides, tarpą ir brūkšnelį.';
      });
      if (key === '0') setWord(ORDER[0].name);
      renderSummary(); syncBar();
    });
  }

  /* ---------- 5. COLOUR ------------------------------------------ */
  function byId(id) {
    for (var i = 0; i < COLORS.length; i++) if (COLORS[i].id === id) return COLORS[i];
    return COLORS[0];
  }
  function pairKey(t, b) { return t.id + '|' + b.id; }

  // the photograph of a pair, for the colourways that have been shot
  /* Every combination is photographed — 7x7, one file per pair — so the path is
     derived rather than looked up. That is the whole reason COLORS ids are the
     English colour words: `bowo-<top>--<base>.jpg` falls straight out of the
     pair, a custom selection resolves exactly like a preset, and there is no
     table to keep in sync with the filesystem.
     Double hyphen between the halves on purpose: the ids themselves contain
     single hyphens (desert-tan, moss-green), so a single separator would not
     parse back. */
  function pairImg(t, b) { return asset(IMG_L + 'bowo-' + t.id + '--' + b.id + '.jpg'); }

  /* The studio's block: the photograph of the chosen pair when one exists, the
     drawing when it does not. Five of the eight presets are shot; the other
     three and every custom pair fall back — and the drawing is the only version
     that can carry the engraved name, which is why it is still here. */
  /* Two layers taking turns. A src swap lands in one frame while the ground
     beside it takes 760ms, and the mismatch reads as a flick — so the incoming
     image is decoded first, then faded up as the outgoing one fades away.
     Returns a setter; call it with '' to fade everything out. */
  function fader(a, b, onReveal) {
    var on = null;
    return function (src, alt) {
      if (!a || !b) return;
      if (!src) { a.classList.remove('is-on'); b.classList.remove('is-on'); on = null; return; }
      if (on && on.getAttribute('src') === src) { if (onReveal) onReveal(); return; }

      var cur = on, next = cur === a ? b : a;
      function reveal() {
        next.classList.add('is-on');
        if (cur) cur.classList.remove('is-on');
        on = next;
        if (onReveal) onReveal();
      }
      next.alt = alt || '';
      // Never start a fade on a frame with nothing to fade to. Cached images
      // report complete synchronously, so this is instant in practice — boot
      // preloads every one of them for exactly that reason.
      if (next.getAttribute('src') !== src) { next.onload = reveal; next.src = src; }
      if (next.complete) reveal(); else next.onload = reveal;
    };
  }

  var studioFade = null, heroFade = null, heroShotFade = null;

  function setStudioShot(l) {
    var svg = $('[data-bowl]');
    if (!svg) return;
    if (!studioFade) {
      studioFade = fader($('[data-studio-img="a"]'), $('[data-studio-img="b"]'),
        function () { svg.classList.remove('is-on'); });
    }
    var src = pairImg(l.top, l.base);
    studioFade(src, src ? 'BOWO stovas · ' + l.top.n + ' / ' + l.base.n : '');
    // no photograph for this pair: the drawing comes back up instead
    if (!src) svg.classList.add('is-on');
    /* The overlaid name belongs to the photograph only — the drawing engraves
       its own in SVG, and both at once would print the name twice.

       REMOVE the custom properties rather than setting them to '': an empty
       value is not "unset", it makes the whole var() substitution invalid at
       computed-value time, so `fill` fell back to its INITIAL value — black —
       and the name rendered as hard black type instead of a groove.

       The plinths are blank in this photography, so there is no engraving left
       to sample per finish; every finish uses the one measured average. The
       exception is a near-black plinth: multiply cannot darken black, so the
       name would simply vanish. Those switch to `screen` with a dark tint,
       which lifts the groove instead — the same read, inverted. */
    /* DARK SINCE 2026-08-26. The renders that landed that day print BOWO on the
       plinth, so a name laid over the same band would read as two marks arguing
       with each other — and the arc below was fitted to the old tapered cone's
       plinth, which this straight-walled form does not have. The name moved to
       the mark behind the photograph instead (see setWord). Everything below is
       left standing and current: when the plinths come back blank, this is one
       `false` away from working again, and the arc needs re-measuring. */
    var PLINTH_IS_BLANK = false;
    var nm = $('[data-block-name]');
    if (nm) {
      nm.classList.toggle('is-on', PLINTH_IS_BLANK && !!src);
      var h = l.base.hex, lum = 0.2126 * parseInt(h.substr(1,2),16)
                              + 0.7152 * parseInt(h.substr(3,2),16)
                              + 0.0722 * parseInt(h.substr(5,2),16);
      if (lum < 60) {                       // near-black plinth: lighten, do not darken
        nm.style.setProperty('--bn-mul', '#202020');
        nm.style.setProperty('--bn-blend', 'screen');
      } else {
        nm.style.removeProperty('--bn-mul');
        nm.style.removeProperty('--bn-blend');
      }
    }
  }

  // the hero wears the two-unit shot of whichever pair is selected
  function setHeroShot(l) {
    if (!heroFade) heroFade = fader($('[data-hero-img="a"]'), $('[data-hero-img="b"]'));
    // the mobile copy under the swatches, cross-fading in step with the block
    if (!heroShotFade) heroShotFade = fader($('[data-hero-shot="a"]'), $('[data-hero-shot="b"]'));
    /* Every PRESET has its own two-unit shot, named the same way the singles are
       — `bowo-pair--<top>--<base>.jpg` — so the path is derived rather than
       stored, exactly like pairImg(). Only the presets were shot as pairs,
       though, so the lookup below is what tells a preset from a custom pick. */
    var k = pairKey(l.top, l.base), exact = false;
    for (var i = 0; i < PAIRS.length; i++) {
      if (PAIRS[i].top + '|' + PAIRS[i].base === k) { exact = true; break; }
    }
    /* A custom combination has no two-unit photograph, so it falls back to the
       SINGLE shot of the very pair selected rather than to a generic duo. That
       shows the customer their actual colours — one stand instead of two, which
       is a smaller lie than two stands in the wrong finish — and it keeps the
       hero inside the same shoot. HERO_DUO, the old warm-backdrop pair shot, is
       no longer reachable. */
    var duo = exact ? 'bowo-pair--' + l.top.id + '--' + l.base.id + '.jpg'
                    : 'bowo-' + l.top.id + '--' + l.base.id + '.jpg';
    heroFade(asset(IMG_L + duo), (exact ? 'Du BOWO stovai · ' : 'BOWO stovas · ')
      + l.top.n + ' / ' + l.base.n);
    // alt stays empty here — see the aria-hidden note on .hero__shot
    heroShotFade(asset(IMG_L + duo), '');
  }


  /* Every other frame that shows "this pair" — the order cards and the summary
     thumbnails. A pair with no photograph falls back to the object's own 72/28
     split rather than to an empty frame, so nothing changes height as you click
     the chips. */
  function setShot(fig, l) {
    if (!fig) return;
    var src = pairImg(l.top, l.base);
    var frame = $('[data-shot-f]', fig) || fig;
    var img = $('img', fig), cap = $('[data-shot-cap]', fig);
    frame.style.background = src ? '' :
      'linear-gradient(' + l.top.hex + ' 0 72%,' + l.base.hex + ' 72% 100%)';
    if (img) {
      img.hidden = !src;
      if (src) {
        if (img.getAttribute('src') !== src) img.src = src;
        img.alt = 'BOWO stovas · ' + l.top.n + ' / ' + l.base.n;
      }
    }
    if (cap) cap.textContent = l.top.n + ' / ' + l.base.n;
  }

  /* ONE colour control, wired three ways: the hero (body finish only), the
     studio, and every order line. The element carries data-colour="<line>" and
     whichever of the four wrappers it needs; anything absent is skipped. */
  function colourUI(el) {
    var key = el.dataset.colour;
    var line = function () { return target(key); };

    var pairWrap = $('[data-dots-pair]', el);
    var set = el.dataset.pairSet;
    if (pairWrap) PAIRS.filter(function (p) {
      return set !== 'hero' || p.hero !== false;
    }).forEach(function (p) {
      var t = byId(p.top), b = byId(p.base);
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', 'false');
      btn.setAttribute('aria-label', t.n + ' su ' + b.n);
      btn.title = t.n + ' / ' + b.n;
      btn.dataset.pair = pairKey(t, b);
      btn.innerHTML = '<span style="background:linear-gradient(135deg,' +
        t.hex + ' 0 50%,' + b.hex + ' 50% 100%)"></span>';
      // Both parts in one tick: the browser only sees the finished pair, so the
      // 760ms morph runs once instead of stepping through a half-applied combo.
      btn.addEventListener('click', function () {
        var l = line(); if (!l) return;
        l.top = t; l.base = b; state.picked = true; refresh();
      });
      pairWrap.appendChild(btn);
    });

    ['top', 'base'].forEach(function (part) {
      var wrap = $('[data-dots-' + part + ']', el);
      if (!wrap) return;
      COLORS.forEach(function (c) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('aria-checked', 'false');
        btn.setAttribute('aria-label', c.n);
        btn.title = c.n;
        btn.dataset.cid = c.id;
        btn.innerHTML = '<span style="background:' + c.hex + '"></span>';
        btn.addEventListener('click', function () {
          var l = line(); if (!l) return;
          l[part] = c; state.picked = true; refresh();
        });
        wrap.appendChild(btn);
      });
    });

    /* Presets are the default view; the nine-by-nine grid is the way out of it
       for anyone who wants a pair we do not put forward. */
    var btns = $$('[data-mode]', el), views = $$('[data-view]', el);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
        views.forEach(function (v) { v.classList.toggle('is-on', v.dataset.view === b.dataset.mode); });
      });
    });
  }

  // live query rather than a registry — order lines are rebuilt, and a stale
  // registry pointing at removed nodes is a silent no-op that is hard to see
  function syncColour() {
    $$('[data-colour]').forEach(function (el) {
      var l = target(el.dataset.colour);
      if (!l) return;
      var key = pairKey(l.top, l.base), e;
      $$('[data-dots-pair] button', el).forEach(function (b) {
        b.setAttribute('aria-checked', b.dataset.pair === key ? 'true' : 'false');
      });
      $$('[data-dots-top] button', el).forEach(function (b) {
        b.setAttribute('aria-checked', b.dataset.cid === l.top.id ? 'true' : 'false');
      });
      $$('[data-dots-base] button', el).forEach(function (b) {
        b.setAttribute('aria-checked', b.dataset.cid === l.base.id ? 'true' : 'false');
      });
      if ((e = $('[data-pair-name]', el))) e.textContent = l.top.n + ' / ' + l.base.n;
      if ((e = $('[data-top-name]',  el))) e.textContent = l.top.n;
      if ((e = $('[data-base-name]', el))) e.textContent = l.base.n;
    });
    setStudioShot(ORDER[0]);
    setHeroShot(ORDER[0]);
  }

  /* Only line one paints the page: the ground follows the body finish, so a
     second stand in a different pair must not repaint the room around it. */
  function repaint() {
    var top = ORDER[0].top, base = ORDER[0].base;
    if (studioEl) paintEl(studioEl, top.bg, top.ink, top.dark);
    // Set on the root, not on the preview: the studio drawing and the size
    // drawings are the same object at two scales and must never disagree.
    root.style.setProperty('--fill', top.hex);
    root.style.setProperty('--top',  top.hex);
    root.style.setProperty('--base', base.hex);
    if (hero.el) {
      hero.el.style.setProperty('--fill', top.hex);
      heroPaint();
    }
  }

  // everything downstream of any change, in one call — cheap on a click, and
  // it removes the whole class of bug where one view of the order goes stale
  function refresh() { repaint(); syncColour(); syncLines(); renderSummary(); syncBar(); }

  /* ---------- 6. SIZES (editorial) -------------------------------- */
  // both blocks built from SIZES, so a dimension can only be wrong in one place
  function renderDims() {
    /* The elevation lives INSIDE its size's entry rather than in a second grid
       underneath. Two parallel grids only look paired because both happen to be
       three columns wide — the moment the phone stacks them you get three
       descriptions and then three unrelated drawings. As one entry they stay
       together at every width, and it costs nothing on desktop: the drawing is
       pushed to the bottom of a stretched cell, which is where `align-items:end`
       used to put it. `dl > div > (dt, dd…)` is valid; a second wrapper around
       the dt is not, so the parts stay flat. */
    var dl = $('[data-dims]');
    /* Every fact is LABELLED now. The weight range and the breeds used to be two
       unlabelled lines under the name, set at 13px and 12px in --ink-70 and
       --ink-25 — which made the breeds, the one line that tells a customer
       "this is your dog", the faintest thing in the section. They read as a
       caption on the drawing rather than as the answer to a question.
       Capacity and price came off the plate for the same reason: they were 11px
       mono in --ink-45, below a drawing, and the price of the product is not a
       footnote. */
    if (dl) dl.innerHTML = SIZES.map(function (s) {
      return '<div class="dims__i">' +
        '<dt><span class="num">' + s.k + '</span> · ' + s.name + '</dt>' +
        '<dd class="dims__f"><p class="dims__k">Šuns svoris</p>' +
          '<p class="dims__v dims__v--w"><span class="num">' + s.w + '</span></p></dd>' +
        '<dd class="dims__f"><p class="dims__k">Dažniausios veislės</p>' +
          '<p class="dims__v">' + s.breeds + '</p></dd>' +
        '<dd class="dims__spec">' + specPlate(s) + '</dd>' +
        '<dd class="dims__c"><span class="num">' + s.ml + ' ml</span>' +
          '<b class="num">' + eur(s.price) + '</b></dd>' +
      '</div>';
    }).join('');
  }

  /* A specimen plate per size: an outline elevation with its two dimensions
     drawn as rules rather than written as a sentence. Every viewBox is 200
     units tall and the CSS fixes the height, so one unit is one unit across the
     row and the three drawings stand in true relative scale to each other. */
  var SPEC_K = 6.6;                                   // viewBox units per cm
  /* REDRAWN 2026-08-26 for the v2 form. The old plate was a tapered cone —
     narrowest at the rim, widest at the foot, one straight run between them.
     The object is now a STRAIGHT-WALLED cylinder with a bone-shaped cutout
     through the wall, so the silhouette is a rectangle and the cutout is the
     feature that tells the two forms apart.

     Traced off the v2 renders, not guessed, with the object segmented by
     DIFFERENCING two colourways (charcoal/charcoal against desert-tan/
     desert-tan) rather than thresholding luminance: this backdrop is textured
     and carries a hard diagonal shadow, so no absolute threshold survives it,
     and the steel bowl is identical in every colourway — it cancels in the
     difference, which conveniently leaves the coloured wall alone.

     - Walls: the silhouette runs 326px wide at the rim and 307px at the foot,
       which is PERSPECTIVE, not taper — the top of the object is nearer the
       lens. SPEC_RIM is 1: rim ⌀ = foot ⌀.
     - Plinth: the seam sits at y 615 where the silhouette's sides are 422 (rim)
       and 660 (foot), so 45 of 238 = 0.19 of the height. Measured at the
       silhouette EDGES on purpose: the seam is a circle in perspective, so at
       the centre of the object it reads about 7px lower than it truly is.
     - Cutout: 41px tall against a 326px diameter = 0.126. Its WIDTH cannot be
       measured from these renders — the cutout is about 50 degrees around the
       cylinder in every one of them, so it is foreshortened to 39px, and the
       printed photographs in the strip are rotated too (the widest reading of
       the four is 1.46:1). 2:1 is the ordinary proportion of the shape and sits
       just above the widest measurement; if a straight-on render ever lands,
       measure it and correct SPEC_BW.
     - The cutout's centre is 0.37 down the wall, rim to seam. */
  var SPEC_RIM = 1;      // rim ⌀ ÷ foot ⌀ — straight walls
  var SPEC_PF  = 0.19;   // plinth height ÷ overall height
  var SPEC_BH  = 0.126;  // cutout height ÷ foot ⌀
  var SPEC_BW  = 0.252;  // cutout width ÷ foot ⌀ (2 x its height)
  var SPEC_BY  = 0.37;   // cutout centre, as a share of the wall, rim to seam
  /* viewBox margins, left and right. They are NOT equal: everything that hangs
     off the object — the height rule, its label — lives on the right, and the
     plate is left-aligned in its column, so the left margin is only enough to
     keep the silhouette off the edge. Equal margins were tried when the plates
     were centred; left-aligning them again turned that symmetry into a 70-unit
     indent. See specPlate for what the right side has to fit. */
  var SPEC_ML  = 10;
  var SPEC_MR  = 70;

  /* The cutout as ONE filled path: a waist bar plus four lobes, drawn as
     overlapping subpaths so their union is the silhouette and no internal edges
     show. Filled rather than outlined because the plate is small — an S plate
     renders about 100px tall, which puts the cutout at 12px wide, and an
     outline at that size fills in and reads as a smudge. A hole that reads as a
     solid mark is also what the photograph shows: it is a through-hole onto
     shade. */
  function bonePath(cx, cy, bw, bh, r) {
    var a = bw / 2, off = bh / 2 - r, wy = bh * 0.17;
    /* sweep flag 1, matching the bar's own clockwise winding. With 0 the lobes
       wound the other way and `fill-rule:nonzero` SUBTRACTED them where they
       overlapped the bar, so the bone came out notched at all four joints. */
    function circle(x, y) {
      return 'M' + (x - r) + ' ' + y +
             'a' + r + ' ' + r + ' 0 1 1 ' + (2 * r) + ' 0' +
             'a' + r + ' ' + r + ' 0 1 1 ' + (-2 * r) + ' 0Z';
    }
    return 'M' + (cx - a + r * 0.5) + ' ' + (cy - wy) +
           'H' + (cx + a - r * 0.5) + 'V' + (cy + wy) +
           'H' + (cx - a + r * 0.5) + 'Z' +
           circle(cx - a + r, cy - off) + circle(cx - a + r, cy + off) +
           circle(cx + a - r, cy - off) + circle(cx + a - r, cy + off);
  }

  function specPlate(s) {
    var r = function (n) { return Math.round(n * 10) / 10; };
    var w = s.d * SPEC_K, h = s.h * SPEC_K;
    /* The right margin has to fit what hangs off the object: the height rule
       stands 20 units out from the silhouette, its label starts 8 past that,
       and "20 cm" is about 33 units of 11px mono. 70 covers it with air; 46
       clipped the label at the viewBox edge. */
    var y0 = 150, x0 = SPEC_ML, cx = r(x0 + w / 2);
    var y1 = r(y0 - h * SPEC_PF), y2 = r(y0 - h);     // seam, top of the drawing
    var tw = w * SPEC_RIM;                            // rim — the same ⌀ now
    /* The height `h` is the whole object, so the rim ellipse has to live INSIDE
       it. It used to be centred on y2 and bulged its own ry above the top line,
       which stretched the drawn height past h. The walls start one ry below y2
       and the ellipse's top edge lands on it. */
    var ry = tw * 0.08;                               // rim ellipse, vertical semi-axis
    var yb = r(y2 + ry);                              // where the walls begin
    var bw = w * SPEC_BW, bh = w * SPEC_BH;
    /* SPEC_BY is where the cutout sits on a wall with room for it. On the S the
       wall is 4.9cm of a 6cm object, and 0.37 down it put the bone's top edge
       INSIDE the rim ellipse's lower arc — it read as sitting on the line. So
       the share is a target, not a rule: the bone is held clear of the ellipse
       (which reaches yb + ry) and clear of the seam, and if the band between
       them is tighter than the bone it centres in what there is. Only the S is
       constrained; the M and L keep their 0.37 untouched. */
    var bh2 = w * SPEC_BH / 2, gap = 2;
    var lo = yb + ry + gap + bh2, hi = y1 - gap - bh2;
    var by = yb + (y1 - yb) * SPEC_BY;                // cutout centre
    by = r(lo > hi ? (yb + ry + y1) / 2 : Math.min(Math.max(by, lo), hi));
    var dx = r(x0 + w + 20);                          // the vertical dimension line
    var W = Math.round(w + SPEC_ML + SPEC_MR);
    function tick(x, y, ax, ay) {
      return '<path d="M' + r(x - ax) + ' ' + r(y - ay) + 'L' + r(x + ax) + ' ' + r(y + ay) + '"/>';
    }
    return '<div class="specs__i">' +
      '<svg viewBox="0 0 ' + W + ' 200" role="img" aria-label="' + s.name + ', ' +
          s.h + ' cm aukščio, skersmuo ' + s.d + ' cm">' +
        // One closed silhouette, not a body stacked on a plinth: drawn
        // separately their edges coincide at the joint and the doubled line
        // reads as a smudge at S size. The seam is an internal line, which is
        // what the object does — the wall does not change direction there.
        '<g class="specs__o">' +
          '<path d="M' + r(cx - w / 2) + ' ' + yb + 'V' + y0 +
            'H' + r(cx + w / 2) + 'V' + yb + '"/>' +
          '<path d="M' + r(cx - w / 2) + ' ' + y1 + 'H' + r(cx + w / 2) + '"/>' +
          '<ellipse cx="' + cx + '" cy="' + yb + '" rx="' + r(tw / 2) + '" ry="' + r(ry) + '"/>' +
        '</g>' +
        '<path class="specs__b" d="' + bonePath(cx, by, r(bw), r(bh), r(bh * 0.32)) + '"/>' +
        '<g class="specs__r">' +
          '<path d="M' + dx + ' ' + y2 + 'V' + y0 + '"/>' + tick(dx, y2, 4, 0) + tick(dx, y0, 4, 0) +
          '<path d="M' + r(cx - w / 2) + ' ' + (y0 + 18) + 'H' + r(cx + w / 2) + '"/>' +
          tick(cx - w / 2, y0 + 18, 0, 4) + tick(cx + w / 2, y0 + 18, 0, 4) +
        '</g>' +
        '<text class="specs__l" x="' + r(dx + 8) + '" y="' + r((y0 + y2) / 2) +
          '" dominant-baseline="middle">' + s.h + ' cm</text>' +
        '<text class="specs__l" x="' + cx + '" y="' + (y0 + 34) +
          '" text-anchor="middle">⌀ ' + s.d + ' cm</text>' +
      '</svg>' +
    '</div>';
  }

  /* ---------- 7. ORDER: the configurator -------------------------- */
  function step(n, t, body) {
    return '<div class="cfg__step"><p class="cfg__lab">' +
      '<span class="num">0' + n + '</span> ' + t + '</p>' + body + '</div>';
  }

  function colourHTML(key) {
    return '<div class="cfg__col" data-colour="' + key + '">' +
      '<div class="mode" role="group" aria-label="Spalvų pasirinkimo būdas">' +
        '<button class="mode__b" type="button" aria-pressed="true"  data-mode="pairs">Deriniai</button>' +
        '<button class="mode__b" type="button" aria-pressed="false" data-mode="custom">Savas derinys</button>' +
      '</div>' +
      '<div class="pals">' +
        '<div class="pals__v is-on" data-view="pairs">' +
          '<div class="dots dots--pair" role="radiogroup" aria-label="Paruoštas derinys" data-dots-pair></div>' +
          '<p class="cfg__pick">Pasirinkta: <strong data-pair-name></strong></p>' +
        '</div>' +
        '<div class="pals__v" data-view="custom">' +
          '<div class="pal"><p class="studio__lab">Viršus · <strong data-top-name></strong></p>' +
            '<div class="dots" role="radiogroup" aria-label="Viršaus atspalvis" data-dots-top></div></div>' +
          '<div class="pal"><p class="studio__lab">Pagrindas · <strong data-base-name></strong></p>' +
            '<div class="dots" role="radiogroup" aria-label="Pagrindo atspalvis" data-dots-base></div></div>' +
          // the same offer the studio makes, because this is the same control
          '<p class="pal__ask">Nerandate norimos spalvos? <a data-contact>Susisiekite</a></p>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function lineHTML(i) {
    return '<header class="cfg__h">' +
        // The product's name, not its position in the list. Additional stands
        // still need telling apart, so those keep an ordinal; line one, which
        // is the only one most orders have, reads as the product alone.
        '<span class="cfg__n">BOWO pakeltas dubenėlis' +
          (i ? ' · ' + (i + 1) : '') + '</span>' +
        (i ? '<button class="cfg__x" type="button" data-rm>Pašalinti</button>' : '') +
      '</header>' +
      // Photograph and size sit side by side from 901px up: the shot is portrait
      // and showing it whole makes it tall, which would otherwise push every
      // control below the fold. Stacks back to shot-then-size on a phone.
      '<div class="cfg__top">' +
        '<figure class="cfg__shot" data-shot><img alt="" width="900" height="900" loading="lazy"></figure>' +
        step(1, 'Dydis',   '<div class="szs" role="radiogroup" aria-label="Dydis" data-szs></div>') +
      '</div>' +
      step(2, 'Spalva',  colourHTML(i)) +
      step(3, 'Augintinio vardas',
        '<input class="studio__in" type="text" data-name-for="' + i + '" maxlength="12" ' +
          'placeholder="GRIKIS" autocomplete="off" spellcheck="false" aria-label="Augintinio vardas">' +
        '<p class="studio__help"><span class="num" data-name-count="' + i + '">0</span>' +
          '/12 · didžiosios raidės, tarpas, brūkšnelis</p>' +
        '<p class="studio__warn" data-name-warn="' + i + '" hidden></p>') +
      step(4, 'Vandens dubenėlis',
        '<button class="addon" type="button" aria-pressed="false" aria-expanded="false" data-water>' +
          '<span class="addon__box" aria-hidden="true"></span>' +
          '<span class="addon__b"><b>Antras stovas vandeniui</b>' +
            '<i>Prasideda nuo to paties derinio, bet dydį, spalvas ir vardą renkatės atskirai.</i></span>' +
          '<span class="addon__p num" data-water-p></span>' +
        '</button>' +
        /* Always in the DOM, only hidden — rebuilding the card on every toggle
           would rewire the controls and steal focus from whatever is typing. */
        '<div class="wtr" data-wtr hidden>' +
          /* The water bowl is configured like a product, so it is SHOWN like
             one: its own packshot beside its own size list, exactly as the
             stand above it. It is a separate photograph because it is a
             separate pair — the add-on starts from the stand's combination but
             the customer can take it anywhere from there, and a card that kept
             showing the stand's finish would quietly contradict its own
             swatches. */
          '<div class="wtr__step wtr__top">' +
            '<figure class="cfg__shot" data-shot-w>' +
              '<img alt="" width="900" height="900" loading="lazy"></figure>' +
            '<div><p class="cfg__sub">Dydis</p>' +
              '<div class="szs" role="radiogroup" aria-label="Vandens dubenėlio dydis" data-szs-w></div></div>' +
          '</div>' +
          '<div class="wtr__step"><p class="cfg__sub">Spalva</p>' + colourHTML(i + 'w') + '</div>' +
          '<div class="wtr__step"><p class="cfg__sub">Vardas</p>' +
            '<input class="studio__in" type="text" data-name-for="' + i + 'w" maxlength="12" ' +
              'placeholder="GRIKIS" autocomplete="off" spellcheck="false" ' +
              'aria-label="Vardas ant vandens dubenėlio">' +
            '<p class="studio__help"><span class="num" data-name-count="' + i + 'w">0</span>' +
              '/12 · didžiosios raidės, tarpas, brūkšnelis</p>' +
            '<p class="studio__warn" data-name-warn="' + i + 'w" hidden></p></div>' +
        '</div>') +
      step(5, 'Kiekis',
        '<div class="qty" role="group" aria-label="Kiekis">' +
          '<button type="button" data-q="-1" aria-label="Mažiau">−</button>' +
          '<span class="num" data-q-val aria-live="polite">1</span>' +
          '<button type="button" data-q="1" aria-label="Daugiau">+</button>' +
        '</div>');
  }

  function renderLines() {
    var wrap = $('[data-lines]');
    if (!wrap) return;
    wrap.innerHTML = '';
    ORDER.forEach(function (l, i) {
      var art = document.createElement('article');
      art.className = 'cfg';
      art.dataset.line = i;
      art.innerHTML = lineHTML(i);
      wrap.appendChild(art);

      // the same three rows twice: once for the stand, once for its water bowl
      [['[data-szs]', ''], ['[data-szs-w]', 'w']].forEach(function (pair) {
        var wrap = $(pair[0], art), w = pair[1];
        if (!wrap) return;
        SIZES.forEach(function (s) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'sz';
          b.setAttribute('role', 'radio');
          b.setAttribute('aria-checked', 'false');
          b.dataset.size = s.key;
          b.innerHTML =
            '<span class="sz__k num">' + s.k + '</span>' +
            /* Weight, height, capacity — the three questions asked of a size, in
               the order they are asked. Capacity was only on the sizes section
               upstairs, which is the wrong place for it: by the time someone is
               picking a row here they are deciding how much food fits, not
               reading an editorial. Same string for the stand and its water
               bowl, where millilitres matter more than anywhere. */
            /* Non-breaking inside each fact, so the line can only break AT a
               separator. The column is narrow enough that three facts wrap, and
               left alone it split "12 cm / aukščio" — a measurement torn from
               its unit, which is the one break that reads as a mistake. */
            '<span class="sz__b"><b>' + s.name + '</b>' +
              '<i>' + nb(s.w) + ' · ' + nb(s.h + ' cm aukščio') +
                ' · ' + nb(s.ml + ' ml') + '</i></span>' +
            '<span class="sz__p num">' + eur(w ? waterPrice(s) : s.price) + '</span>';
          b.addEventListener('click', function () {
            var t = target(i + w); if (t) { t.size = s.key; refresh(); }
          });
          wrap.appendChild(b);
        });
      });

      colourUI($('[data-colour="' + i + '"]', art));
      colourUI($('[data-colour="' + i + 'w"]', art));
      bindName($('[data-name-for="' + i + '"]', art));
      bindName($('[data-name-for="' + i + 'w"]', art));

      $('[data-water]', art).addEventListener('click', function () {
        var l = ORDER[i];
        l.water = l.water ? null : newWater(l);
        refresh();
      });
      $$('[data-q]', art).forEach(function (b) {
        b.addEventListener('click', function () {
          ORDER[i].qty = Math.max(1, Math.min(9, ORDER[i].qty + (+b.dataset.q)));
          refresh();
        });
      });
      var rm = $('[data-rm]', art);
      if (rm) rm.addEventListener('click', function () {
        ORDER.splice(i, 1); renderLines(); refresh();
      });
    });
    wireContact(wrap);
    syncLines();
  }

  function syncLines() {
    $$('.cfg').forEach(function (art) {
      var i = +art.dataset.line, l = ORDER[i];
      if (!l) return;
      var e;

      [['[data-szs]', ''], ['[data-szs-w]', 'w']].forEach(function (pair) {
        var t = target(i + pair[1]);
        $$(pair[0] + ' [data-size]', art).forEach(function (b) {
          b.setAttribute('aria-checked', t && b.dataset.size === t.size ? 'true' : 'false');
        });
      });

      if ((e = $('[data-water]', art))) {
        e.setAttribute('aria-pressed',  l.water ? 'true' : 'false');
        e.setAttribute('aria-expanded', l.water ? 'true' : 'false');
      }
      // priced off the water bowl's own size once there is one to price
      if ((e = $('[data-water-p]', art))) e.textContent = '+ ' + eur(waterPrice(sizeOf(l.water || l)));
      if ((e = $('[data-wtr]', art)))     e.hidden = !l.water;
      if ((e = $('[data-q-val]', art)))   e.textContent = l.qty;

      ['', 'w'].forEach(function (w) {
        var t = target(i + w), key = i + w;
        var inp = $('[data-name-for="' + key + '"]', art);
        if (inp && t && inp.value !== t.name) inp.value = t.name;
        var c = $('[data-name-count="' + key + '"]', art);
        if (c && t) c.textContent = t.name.length;
      });

      setShot($('[data-shot]', art), l);
      // only when there IS a water bowl; the panel is hidden otherwise, and
      // setShot on a null line would throw before the summary ever redrew
      if (l.water) setShot($('[data-shot-w]', art), l.water);
    });
  }

  /* ---------- 8. ORDER: the summary ------------------------------- */
  function renderSummary() {
    var list = $('[data-sum-list]');
    if (!list) return;

    /* The water bowl is a configured product, not a checkbox, so it gets a full
       row of its own — photograph, size, pair, name and price — rather than a
       "+ second stand" footnote under the line it was bought with. */
    function row(cfg, qty, price, title, sub) {
      var img = pairImg(cfg.top, cfg.base);
      return '<li class="sl' + (sub ? ' sl--sub' : '') + '">' +
        (img ? '<span class="sl__t"><img src="' + img + '" alt="" loading="lazy"></span>'
             : '<span class="sl__t" style="background:linear-gradient(' + cfg.top.hex +
               ' 0 72%,' + cfg.base.hex + ' 72% 100%)"></span>') +
        '<span class="sl__b">' +
          '<span class="sl__n">' + title + '</span>' +
          '<span class="sl__m">' + cfg.top.n + ' / ' + cfg.base.n + '</span>' +
          '<span class="sl__m">' +
            (cfg.name ? 'Vardas: <b>' + cfg.name + '</b>' : 'Vardas dar neįrašytas') +
            ' · ' + qty + ' vnt.</span>' +
        '</span>' +
        '<span class="sl__p num">' + eur(price) + '</span>' +
      '</li>';
    }

    list.innerHTML = ORDER.map(function (l) {
      var s = sizeOf(l);
      var out = row(l, l.qty, s.price * l.qty, s.k + ' · ' + s.name, false);
      if (l.water) {
        var ws = sizeOf(l.water);
        out += row(l.water, l.qty, waterPrice(ws) * l.qty,
          'Vandens dubenėlis · ' + ws.k + ' · ' + ws.name, true);
      }
      return out;
    }).join('');

    var sub = orderSubtotal(), on = giftOn(), e;
    var gift = $('[data-gift]');
    if (gift) {
      gift.classList.toggle('is-on', on);
      // "unlocked" only means something when there was a threshold to clear
      $('[data-gift-tag]', gift).textContent =
        !on ? 'Dovana' : GIFT.at > 0 ? 'Dovana atrakinta' : 'Dovana užsakymui';
      $('[data-gift-p]', gift).textContent   = on ? '+ 0 €' : 'nuo ' + eur(GIFT.at);
      $('[data-gift-n]', gift).textContent   = GIFT.n;
      var gi = $('[data-gift-img]', gift);
      if (gi && !gi.getAttribute('src')) { gi.src = asset(IMG_L + GIFT.img); gi.alt = GIFT.n; }
      $('[data-gift-d]', gift).textContent   = on
        ? GIFT.d + ' · jums nemokamai'
        : 'Iki dovanos liko ' + eur(GIFT.at - sub) + '.';
      var barEl = $('[data-gift-bar]', gift);
      barEl.hidden = on;
      $('i', barEl).style.width = Math.min(100, Math.round(sub / GIFT.at * 100)) + '%';
    }

    if ((e = $('[data-sum-sub]')))       e.textContent = eur(sub);
    if ((e = $('[data-sum-giftrow]')))   e.hidden = !on;
    // the gift is free, so it never moves the total — shipping is free too
    if ((e = $('[data-sum-total]')))     e.textContent = eur(sub);
    if ((e = $('[data-checkout]')))      e.textContent = 'Pereiti prie apmokėjimo · ' + eur(sub);
  }

  function syncBar() {
    var c = $('[data-cart-count]');
    if (c) { c.textContent = orderCount(); c.classList.toggle('is-full', orderCount() > 0); }

    var m = $('[data-bar-meta]'), p = $('[data-bar-price]'),
        sw = $('[data-bar-sw]'), nm = $('[data-bar-name]');
    if (!m) return;
    var l = ORDER[0], s = sizeOf(l);
    m.textContent = s.name + ' · ' + l.top.n + ' / ' + l.base.n +
      (ORDER.length > 1 ? ' +' + (ORDER.length - 1) : '');
    nm.textContent = l.name || '';
    p.textContent = eur(orderSubtotal());
    sw.style.background = 'linear-gradient(' + l.top.hex + ' 0 72%, ' + l.base.hex + ' 72% 100%)';
  }

  function initOrder() {
    var add = $('[data-add-line]');
    if (add) add.addEventListener('click', function () {
      // seeded from the last stand: a second bowl for the same household is
      // usually the same size and finish, with only the name changing
      ORDER.push(newLine(ORDER[ORDER.length - 1]));
      renderLines(); refresh();
      var last = $$('.cfg').pop();
      if (last) $('[data-name-for]', last).focus();
    });

    var co = $('[data-checkout]');
    if (co) co.addEventListener('click', function () {
      // the water bowl carries its own engraving, so it needs its own name
      var blank = null;
      ORDER.forEach(function (l, i) {
        if (blank === null && !l.name) blank = '' + i;
        if (blank === null && l.water && !l.water.name) blank = i + 'w';
      });
      if (blank !== null) {
        var inp = $('[data-name-for="' + blank + '"]');
        if (inp) {
          if (!REDUCED) smoothTo($('#pirkti'));
          setTimeout(function () { inp.focus(); }, REDUCED ? 0 : 700);
        }
        toast('Įrašykite vardą, kurį išliesime');
        return;
      }
      checkout();
    });
  }

  /* ---------- 7b. CHECKOUT ---------------------------------------- */
  /* SHOPIFY, when the page is running as the theme and a product is wired to
     the order section; a toast otherwise, which is what the static page has
     always done. The switch is DATA, not a build flag: #bw-product is rendered
     by Liquid and carries a variant id per size|top|base, so its presence is
     the same question as "are we on a store".

     Line items, not a cart page: ORDER already IS the cart, so every stand and
     every water bowl in it goes to /cart/add.js in ONE call, and the browser is
     handed straight to /checkout. Adding them one request at a time would let a
     half-added order survive a failure in the middle.

     The engraved name travels as a LINE ITEM PROPERTY. It cannot be an option:
     Shopify allows three per product and size, top and base have taken all
     three, and a name is not a variant anyway — it is made to order, one per
     line, and 12 characters of free text would be an infinite catalogue. */
  var PRODUCT = (function () {
    try {
      var el = document.getElementById('bw-product');
      return el ? JSON.parse(el.textContent) : null;
    } catch (e) { return null; }
  })();

  /* Keyed on the option VALUES, which are the Lithuanian names — those are what
     the cart line and the packing slip will read, so they are what the product
     carries. The ids live in the SKU instead, for the workshop. tools/product-
     csv.py generates the catalogue from these same two arrays, so the only way
     for the key to miss is renaming a finish here without re-importing.

     Built in the PRODUCT'S option order, not ours. Liquid numbers options by
     position, and a product edited by hand in admin can end up with them in
     any order; assuming Dydis|Viršus|Pagrindas would then silently miss every
     variant. Option names we do not recognise are reported rather than
     guessed — swapping Viršus and Pagrindas would check out the wrong object,
     which is worse than not checking out at all. */
  var OPT_FALLBACK = ['Dydis', 'Viršus', 'Pagrindas'];
  function variantKey(l) {
    var by = {};
    by['Dydis'] = sizeOf(l).name;
    by['Viršus'] = l.top.n;
    by['Pagrindas'] = l.base.n;
    var names = (PRODUCT && PRODUCT.options && PRODUCT.options.length === 3)
      ? PRODUCT.options : OPT_FALLBACK;
    var parts = [], unknown = [];
    names.forEach(function (n) {
      var v = by[String(n).trim()];
      if (v === undefined) { unknown.push(n); v = ''; }
      parts.push(v);
    });
    return { key: parts.join('|'), unknown: unknown };
  }
  function variantId(l) {
    if (!PRODUCT || !PRODUCT.variants) return null;
    var k = variantKey(l);
    var id = PRODUCT.variants[k.key];
    if (!id && window.console) {
      console.warn('[BOWO] no variant for "' + k.key + '".' +
        (k.unknown.length
          ? ' The product\'s options are named ' + JSON.stringify(PRODUCT.options) +
            ' — they have to be Dydis / Viršus / Pagrindas.'
          : ' The product has ' + PRODUCT.variant_count + ' variants; an example key is "' +
            Object.keys(PRODUCT.variants)[0] + '". Values must match SIZES[].name and COLORS[].n.'));
    }
    return id || null;
  }

  function checkout() {
    if (!PRODUCT) {
      /* Not Shopify refusing anything — the order section has no product, so
         there are no variant ids to add. The toast stays customer-safe; the
         console says what a person setting the store up needs to hear. */
      if (window.console) {
        console.warn('[BOWO] #bw-product is missing, so checkout is in demo mode. ' +
          'Customize → BOWO order → The stand: pick the product, then save. ' +
          'Uploading a theme zip resets section settings, so this needs doing again after each upload.');
      }
      toast('Demonstracinė versija - apmokėjimas dar neprijungtas');
      return;
    }
    var items = [], missing = false;
    ORDER.forEach(function (l) {
      [[l, l.qty], [l.water, l.qty]].forEach(function (pair) {
        var line = pair[0];
        if (!line) return;
        var id = variantId(line);
        if (!id) { missing = true; return; }
        items.push({ id: id, quantity: pair[1], properties: { 'Vardas': line.name } });
      });
    });
    // A finish with no variant means the catalogue and this page disagree, which
    // is a broken order rather than a slow one — say so instead of checking out
    // a partial basket.
    if (missing || !items.length) {
      toast('Šio derinio nepavyko rasti - parašykite mums');
      return;
    }
    /* CLEAR FIRST, then add. The Shopify cart is not a second place an order is
       kept — it is a projection of ORDER, made at the last possible moment so
       that checkout has something to charge for. Adding without clearing meant
       every press of the button appended: change a size, press again, and both
       versions arrived at checkout, where Bogus Gateway offers no way to remove
       a line. Rewriting the cart wholesale makes that impossible by
       construction, and keeps the promise the page makes — what the summary
       shows IS what gets bought.

       The cost, stated plainly: anything a customer put in the cart by some
       other route is discarded here. With one product and no other path into
       the cart, there is nothing else it could be; if BOWO ever sells a second
       thing from its own page, this has to become a diff rather than a rewrite. */
    fetch(PRODUCT.clear_url || '/cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    }).then(function () {
      return fetch(PRODUCT.add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      window.location.href = PRODUCT.checkout_url || '/checkout';
    }).catch(function () {
      toast('Nepavyko pridėti į krepšelį - bandykite dar kartą');
    });
  }

  /* ---------- 9. STRIP / FAQ ------------------------------------- */
  function initStrip() {
    var s = $('[data-strip]');
    if (!s) return;
    UGC.forEach(function (u) {
      var i = document.createElement('img');
      i.src = asset(IMG_U + u.f); i.loading = 'lazy'; i.alt = u.a;
      // No width/height attributes here. They look like free CLS insurance, but
      // they are presentational hints for the CSS `height` property, and .strip
      // img never sets height — so `height:900` beat `aspect-ratio:1/1` and the
      // row rendered 900px tall. The cell is fully described in CSS already.
      i.draggable = false;
      s.appendChild(i);
    });

    /* The strip has always scrolled — its scrollbar is just hidden, which on a
       mouse makes it look like a static row. Two additions, no new words: a
       rule that shows how far along you are, and drag, which is what most
       people try first. Touch is left alone; it already works. */
    var bar = $('[data-strip-bar]');
    function paint() {
      if (!bar || !s.scrollWidth) return;
      var seen = Math.min(1, s.clientWidth / s.scrollWidth);
      bar.style.width = (seen * 100) + '%';
      bar.style.left  = (s.scrollLeft / s.scrollWidth * 100) + '%';
    }

    var down = false, x0 = 0, l0 = 0;
    s.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; x0 = e.clientX; l0 = s.scrollLeft;
      s.classList.add('is-drag');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      s.scrollLeft = l0 - (e.clientX - x0);
    });
    window.addEventListener('pointerup', function () {
      down = false; s.classList.remove('is-drag');
    });
    s.addEventListener('scroll', paint, { passive: true });
    window.addEventListener('resize', paint, { passive: true });
    // the images are lazy, so the scrollable width is not final until they land
    window.addEventListener('load', paint);
    paint();
  }

  function initFaq() {
    var list = $('[data-faq]');
    if (!list) return;
    FAQ.forEach(function (item, i) {
      var qa = document.createElement('div');
      qa.className = 'qa';
      var id = 'qa-' + i;
      qa.innerHTML =
        '<button class="qa__q" type="button" aria-expanded="false" aria-controls="' + id + '">' +
          '<span>' + item.q + '</span><span class="qa__i" aria-hidden="true"></span></button>' +
        '<div class="qa__a" id="' + id + '" role="region"><div>' + item.a + '</div></div>';
      var btn = qa.querySelector('.qa__q'), pane = qa.querySelector('.qa__a');
      btn.addEventListener('click', function () {
        var open = qa.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        pane.style.height = open ? pane.firstElementChild.offsetHeight + 'px' : '0px';
      });
      list.appendChild(qa);
    });
  }

  /* ---------- 10. TOAST ------------------------------------------ */
  var tt;
  function toast(msg) {
    var t = $('[data-toast]');
    $('[data-toast-txt]').textContent = msg;
    t.hidden = false; void t.offsetHeight; t.classList.add('is-on');
    clearTimeout(tt);
    tt = setTimeout(function () {
      t.classList.remove('is-on');
      setTimeout(function () { t.hidden = true; }, 300);
    }, 2600);
  }

  /* ---------- BOOT ----------------------------------------------- */
  function boot() {
    heroInit();
    chapInit();
    studioWords = $$('[data-studio-word]');
    studioMarks = $$('[data-bowl-mark]');
    // the hero and the studio; order lines wire themselves as they are built
    $$('[data-colour]').forEach(colourUI);
    $$('[data-name-for]').forEach(bindName);
    renderDims();
    // the CTA section states the threshold, so it reads it from GIFT rather
    // than repeating a number that can drift out of step with the summary
    var gl = $('[data-gift-line]');
    if (gl) gl.textContent = GIFT.at > 0
      ? 'Užsakymams nuo ' + eur(GIFT.at)
      : 'Su kiekvienu užsakymu';
    renderLines();
    initOrder();
    initStrip();
    initFaq();
    initAnchors();
    wireContact();
    setWord('');
    refresh();
    if (bar) bar.hidden = false;

    window.addEventListener('scroll', onScroll, { passive: true });
    // no heroMeasure here any more: the hero's ground is a flat fill, so its
    // height stopped being an input the moment the scroll fade was removed
    window.addEventListener('resize', function () {
      // fitWord too: the mark is measured against the section's width, so a
      // name that fits at 1440 can overrun at 900 and nothing else would catch it
      chapMeasure(); fitWord(); onScroll();
    }, { passive: true });
    window.addEventListener('load', chapMeasure);
    // Every pair photograph, once the page itself is done. The cross-fade can
    // only start once the next image has decoded, and a first swap that waits
    // on the network is exactly the flick this is meant to remove.
    window.addEventListener('load', function () {
      PAIRS.forEach(function (p) {
        if (p.img) new Image().src = asset(IMG_L + p.img);
        if (p.duo) new Image().src = asset(IMG_L + p.duo);
      });
    });
    frame();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
